/*
  One line of Settings: what is true now, and the one button that changes it.

  The shape every line on that screen takes, including the ones that are not settings at
  all — a person on the account, an invitation nobody has accepted yet. Keeping them
  identical is what lets the screen grow: the next thing added there is a row, and it will
  already look like it belongs.

  Not to be confused with SettingRow, which is Company's: that one is an editable value
  that turns into a field in place. This one never edits anything itself. It states a fact
  and hands off to a sheet, because the things Settings changes — a password, an invitation
  — are one-off acts with several fields, not values you tweak.

  `label` is the fact, not the field name. "admin@boardium.co", not "Email address". A
  settings page that lists the names of its own inputs makes you open every one of them to
  find out what it currently says.
*/
export function AccountRow({
  label, note, action, tag, muted,
}: {
  label: React.ReactNode
  /** The line underneath: state, dates, consequences. Where the detail goes. */
  note?: React.ReactNode
  /** Usually one button. Rows with nothing to do are still worth showing. */
  action?: React.ReactNode
  /** A short marker beside the label, e.g. "you". */
  tag?: string
  /** For a row that is not a thing yet, like an unaccepted invitation. */
  muted?: boolean
}) {
  return (
    <div className={`srow${muted ? ' srow--muted' : ''}`}>
      <div className="srow__body">
        <div className="srow__label">
          {label}
          {tag && <span className="srow__tag">{tag}</span>}
        </div>
        {note && <div className="srow__note">{note}</div>}
      </div>
      {action && <div className="srow__action">{action}</div>}
    </div>
  )
}
